export default "__VITE_ASSET__DsUG7tfg__"